// filepath: c:\Projects\Catalyte\JA\JAEE-Admin\ja-ee-admin\src\components-lib\icons_\ExpireGreenIcon.tsx
import {AccessTime} from '@material-ui/icons';
import React from 'react';

interface IExpireGreenIconProps {
  disabled?: boolean;
}

export function ExpireGreenIcon({disabled}: IExpireGreenIconProps) {
  return <AccessTime fontSize="small" style={{opacity: disabled ? 0.3 : 1, color: '#006400'}} />;
}
